<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>重要提醒</el-breadcrumb-item>
      <el-breadcrumb-item>设备异常提醒</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- Tabs -->
    <el-tabs v-model="activeName" type="border-card">
      <!-- 清单列表 strat -->
      <el-tab-pane label="清单列表" name="first" disabled="disabled">
        <!-- 查询用户 start -->
        <el-form :inline="true" :model="keywords" ref="keywordsRef" label-width="82px">
          <el-form-item label="">
            <el-input v-model="keywords.loginname" @keyup.enter.native="clicksearch" placeholder="请输入登录名称" style="width: 150px;"></el-input>
          </el-form-item>
          <el-form-item label="">
            <el-input v-model="keywords.name" @keyup.enter.native="clicksearch" placeholder="请输入姓名" style="width: 150px;"></el-input>
          </el-form-item>
          <el-form-item label="">
            <el-input v-model="keywords.mac" @keyup.enter.native="clicksearch" placeholder="请输入MAC地址" style="width: 150px;"></el-input>
          </el-form-item>
          <el-form-item label="">
            <el-input v-model="keywords.cardnumber" @keyup.enter.native="clicksearch" placeholder="请输入保修卡号" style="width: 150px;"></el-input>
          </el-form-item>
          <el-form-item label="">
            <Rsljigou :propsjigouid="keywords.jigouid" :propsjigouname="keywords.jigouname" @change="changeRsljigou"></Rsljigou>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="clicksearch">查询</el-button>
          </el-form-item>
        </el-form>
        <!-- 查询用户 end -->

        <el-table :data="dataList" border stripe>
          <el-table-column prop="Devicestatus" label="设备状态" width="120px">
            <template slot-scope="scope">
              <span style="color: #e95d4e;font-weight: 700;">{{ scope.row.Devicestatus }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="Loginname" label="登录名称" width="120px"></el-table-column>
          <el-table-column prop="Name" label="用户姓名" width="120px"></el-table-column>
          <el-table-column prop="Jigouname" label="归属机构"></el-table-column>
          <el-table-column prop="Mac" label="mac地址"></el-table-column>
          <el-table-column prop="Cardnumber" label="保修卡号"></el-table-column>
          <el-table-column prop="Createtime" label="注册时间"></el-table-column>
          <el-table-column prop="" fixed="right" label="操作" width="250px">
            <template v-slot="scope">
              <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="goViewExceptions(scope.row)">查看异常详情</el-button>
              <el-button type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="goHandlingDeviceExceptions(scope.row)">处理设备异常</el-button>
            </template>
          </el-table-column>
        </el-table>

        <!-- 分页 -->
        <div class="pages">
          <el-pagination
            @current-change="handleCurrentPageChange"
            :page-size="10"
            layout="total, prev, pager, next, jumper"
            :total="dataListnum"
			:current-page.sync="selectedPageNo">
          </el-pagination>
        </div>
      </el-tab-pane>
      <!-- 清单列表 end -->

      <el-tab-pane label="查看异常详情" name="second" disabled="disabled">
        <DeviceExceptionReminderLook ref="SubVueLook" v-on:triggerFunc="BackToFirst"></DeviceExceptionReminderLook>
      </el-tab-pane>

      <el-tab-pane label="处理设备异常" name="three" disabled="disabled">
        <DeviceExceptionReminderHandling ref="SubVueHandling" v-on:triggerFunc="BackToFirst"></DeviceExceptionReminderHandling>
      </el-tab-pane>

    </el-tabs>
    <!-- Tabs end -->
  </div>
</template>

<script>
import Rsljigou from '@/components/Rsljigou.vue'
import DeviceExceptionReminderLook from '@/componentsSubVue/DeviceExceptionReminderLook.vue'
import DeviceExceptionReminderHandling from '@/componentsSubVue/DeviceExceptionReminderHandling.vue'
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  components: {
    Rsljigou,
    DeviceExceptionReminderLook,
    DeviceExceptionReminderHandling
  },
  name: 'MyDeviceExceptionReminder',
  data () {
    return {
      activeName: 'first',
      selectedPageNo: 1,
      dataList: [],
      dataListnum: 0,
      keywords: {
        loginname: '',
        name: '',
        mac: '',
        cardnumber: '',
        jigouid: '-1',
        jigouname: ''
      }
    }
  },
  mounted () {
    this.apiDeviceExceptionRemindernum()
    this.apiDeviceExceptionReminderlist()
  },
  methods: {
    BackToFirst (val) {
      this.activeName = 'first'
    },
    changeRsljigou (vid, vname) {
      this.keywords.jigouid = vid
      this.keywords.jigouname = vname
    },
    handleCurrentPageChange (selectedPageNo) {
      this.apiDeviceExceptionReminderlist()
    },
    clicksearch () {
      this.selectedPageNo = 1
      this.apiDeviceExceptionRemindernum()
      this.apiDeviceExceptionReminderlist()
    },
    apiDeviceExceptionReminderlist: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        pageno: that.selectedPageNo,
        loginname: that.keywords.loginname,
        name: that.keywords.name,
        mac: that.keywords.mac,
        cardnumber: that.keywords.cardnumber,
        jigouid: that.keywords.jigouid
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_DeviceExceptionReminderlist, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataList = response.data.List
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiDeviceExceptionRemindernum: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        loginname: that.keywords.loginname,
        name: that.keywords.name,
        mac: that.keywords.mac,
        cardnumber: that.keywords.cardnumber,
        jigouid: that.keywords.jigouid
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_DeviceExceptionRemindernum, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataListnum = response.data.Num
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    goViewExceptions (row) {
      this.activeName = 'second'
      this.$refs.SubVueLook.LoadData({ name: '', params: { userid: row.Id } })
    },
    goHandlingDeviceExceptions (row) {
      this.activeName = 'three'
      this.$refs.SubVueHandling.LoadData({ name: '', params: { userid: row.Id } })
    }
  }
}
</script>

<style lang="less" scoped>
/deep/ .el-button--mini, .el-button--mini.is-round {
    padding: auto 5px;
}
.select{
   width: 202px;
}

.optometry {
    margin-top: 15px;
    padding: 20px;
    background: #FAFAFA;
    border: 1px solid #EBEEF5;

    & ul{
        flex-wrap: wrap;
        margin: 0;
        padding: 0;

        & li{
            width: 35%;
            line-height: 28px;
            color: #606266;
            list-style: none;
        }
    }
}
.mt20{
   margin-top: 20px;
}
</style>
